import { createContext, memo, ReactNode, useCallback, useContext, useState } from 'react'
import { StyledFilterBar } from './styles'

export type FilterBarProps = {
  children: ReactNode[]
  noBorder?: boolean
  getFilters?: any
}

type FilterContextProps = {
  filters: {}
  onChange: (id: string, filter: string | {}) => void
}

export const FilterContext = createContext<FilterContextProps>({
  filters: {},
  onChange: () => {},
})

export const useFilter = () => {
  const context = useContext(FilterContext)
  if (context === undefined) {
    throw new Error('useFilter must be used within a <Filter /> Component')
  }

  return context
}

export const UnMemoizedFilter = ({ children, noBorder, getFilters }: FilterBarProps) => {
  const [filters, setFilters] = useState({})

  const onChange = useCallback(
    (id: string, filter: string | {}) => {
      setFilters({ ...filters, [id]: filter })
      getFilters({ ...filters, [id]: filter })
    },
    [filters, getFilters],
  )

  return (
    <StyledFilterBar noBorder={noBorder}>
      <FilterContext.Provider value={{ filters, onChange }}>{children}</FilterContext.Provider>
    </StyledFilterBar>
  )
}

export const Filter = memo(UnMemoizedFilter)
